<template>
  <div class="wild-card">
    <div :style="bgStyle" class="wild-card__promo">
      <slot name="promo">
        <img
          v-if="wildcardEvent.logo"
          class="wild-card__logo"
          :src="wildcardEvent.logo"
          :alt="wildcardEvent.name"
        />
      </slot>
    </div>
    <div class="wild-card__body">
      <div class="wild-card__name" v-html="wildcardEvent.name"></div>
      <div class="wild-card__place">{{ wildcardEvent.place }}</div>

      <div class="wild-card__infos">
        <WildCardInfoItem>
          <template #label>
            Разыгрывется слотов
          </template>
          <template #default>
            {{ wildcardEvent.slots }}
          </template>
        </WildCardInfoItem>

        <WildCardInfoItem>
          <template #label>
            Начало
          </template>
          <template #default>
            {{ wildcardEvent.date || "TBD" }}
          </template>
        </WildCardInfoItem>
      </div>

      <div class="text-xs-center">
        <AppBtn
          :disabled="!wildcardEvent.href"
          class="wild-card__btn"
          :href="wildcardEvent.href"
          target="_blank"
          rel="noopener"
          color="yellow-grad"
          border="bottom"
          @click="$app.metrics('click-wildcard-details')"
        >
          Подробнее
        </AppBtn>
      </div>
    </div>
  </div>
</template>

<script>
import WildCardInfoItem from "./WildCardInfoItem";

export default {
  name: "WildCard",
  components: {
    WildCardInfoItem
  },
  props: {
    /** @type {<{date?: string, name: string, place: string, bg: string, logo?:string, slots: number, href?: string}>} */
    wildcardEvent: {
      type: Object,
      required: true
    }
  },
  computed: {
    bgStyle() {
      return {
        "background-image": `url(${this.wildcardEvent.bg})`
      };
    }
  }
};
</script>

<style lang="scss">
.wild-card {
  position: relative;
  background: linear-gradient(
    180deg,
    rgba(30, 33, 53, 0.65) 0,
    rgba(48, 77, 150, 0.65)
  );
  border-radius: 6px;

  display: flex;
  flex-direction: column;

  &__promo {
    height: 165px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    background-size: cover;
    flex-shrink: 0;
  }

  &__body {
    padding: 20px;
    flex-grow: 1;

    display: flex;
    flex-direction: column;
  }

  &__name {
    font-size: 20px;
    font-weight: 800;
    padding-bottom: 0.4em;
    margin-bottom: auto;
  }

  &__place {
    color: colors(text-2);
    font-size: 12px;
  }

  &__logo {
    max-width: 100%;
    max-height: calc(100% - 40px);
    display: block;
    pointer-events: none;
  }

  &__infos {
    margin-top: 20px;
    display: flex;
  }

  &__btn {
    margin: 20px auto 0;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    padding: 10px 28px;
  }

  @include breakpoint("md-only") {
    &__body {
      padding: 16px;
    }
  }

  @include breakpoint("md-and-down") {
    &__infos {
      margin-top: 10px;
    }
    &__name {
      font-size: 18px;
    }
  }

  @include breakpoint("sm-and-down") {
    &__body {
      padding: 16px;
    }
  }
}
</style>
